import components from './components'
import pages from './pages'

export default {
  components,
  pages,
  common: require('common/locales/ja/common'),
}
